import { VisitorGroup } from 'graphql/generated/graphqlTypes';
import { VisitorGroupType } from 'utils/VisitorGroup/VisitorGroup';

export interface VisitorGroupAutocompleteOption {
  label: string;
  value: string;
}

export const getAutocompleteVisitorGroupOptions = (visitorGroups: VisitorGroup[]): VisitorGroupAutocompleteOption[] => {
  return visitorGroups
    .filter((group) => group.type === VisitorGroupType.CoContractors)
    .map((group) => ({
      label: group.name,
      value: group.id
    }));
};
